import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvVariableService {
 configData :{ [key: string]: any} | null = null;

  

  constructor(private readonly http: HttpClient) { }
  //make a query with absolute path to retrieve config file
  loadConfig(): Observable<any> {
  //  const configPath = (window as { [key: string]: any })["manifestConfig"]["botMfe"]["angularBasePath"]+`/assets/json/config.json`;
   const configPath = `/assets/json/config.json`;
    return this.http.get(configPath);
  }

  //store the config file in the service
  setConfig(config:any)
  {
    this.configData = config
  }

  //return a value from the config file
  getConfigKey(key:any)
  {
    if(this.configData){
    return this.configData[key]
    }
    return null;
  }
}
